import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type UiState = {
  headerTitle: string;
};

const initialState: UiState = {
  headerTitle: "",
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setHeaderTitle(state, action: PayloadAction<string>) {
      state.headerTitle = action.payload;
    },
  },
});

export const { setHeaderTitle } = uiSlice.actions;
export default uiSlice.reducer;
